import global from './global';
import Vue from 'vue';

Object.keys(global).forEach(key => {
    Vue.filter(key, global[key]);
});